import React from 'react'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Our_product.css"
import Common_heading from '../../common_component/common_heading/Common_heading'
import Our_product_card from './our_product_card/Our_product_card';
import productData from '../../products/productData/ProductData';

function Our_product() {
    return (
        <>
            <section className='Our_product'>
                <div className="container">
                    <Common_heading title="OUR PRODUCT" subTitle="Integrated Solutions Across The Supply Chain From Sourcing To Delivery." />

                    <div className='swiper_holder'>
                        <Swiper className="product_mySwiper"
                            slidesPerView={3.5}
                            spaceBetween={50}
                            breakpoints={{
                                // when window width is >= 320px
                                320: {
                                    slidesPerView: 1.3,
                                    spaceBetween: 10,
                                },
                                // when window width is >= 480px
                                480: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                // when window width is >= 768px
                                768: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 30,
                                },
                                // when window width is >= 1024px
                                1024: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 30,
                                },

                                // when window width is >= 1400px
                                1400: {
                                    slidesPerView: 4.5,
                                    spaceBetween: 50,
                                },
                            }}>
                            {productData.map((product, i) => (
                                <SwiperSlide key={i} >
                                    <Link to={`/products/${product.id}`} >
                                        <Our_product_card
                                            imgSrc={product.cardImage}
                                            title={product.title}
                                            subTitle={product.subTitle}
                                        />
                                    </Link>
                                </SwiperSlide>
                            ))}


                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Our_product